import { AlgoliaQuery } from 'ha/services/algolia';
import { filterBuilder } from 'ha/modules/Algolia';
import getGeoBoundaryFilter from './getGeoBoundaryFilter';
import getFilterParams from './getFilterParams';
import { ReqParams, SearchParams, CurrencyEuroRates } from './types';

const queryFilterBuilder = filterBuilder();
const priceFacetFilterBuilder = filterBuilder({ priceEUR: () => '' });

export default (
  reqParams: ReqParams,
  searchParams: SearchParams,
  currencyEuroRates: CurrencyEuroRates,
): AlgoliaQuery[] => {
  const geoBoundaryFilter = getGeoBoundaryFilter(reqParams, searchParams);
  const filterParams = getFilterParams(reqParams, currencyEuroRates);
  const filters = queryFilterBuilder(filterParams);
  const priceFacetFilters = priceFacetFilterBuilder(filterParams);

  const priceFacet = {
    query: '',
    params: {
      distinct: true,
      facets: ['priceEUR'],
      insideBoundingBox: geoBoundaryFilter,
      filters: priceFacetFilters,
      hitsPerPage: 0,
    },
  };

  const partnerFacet = {
    query: '',
    params: {
      distinct: true,
      facets: ['isPartner'],
      insideBoundingBox: geoBoundaryFilter,
      filters,
      hitsPerPage: 0,
    },
  };

  return [priceFacet, partnerFacet];
};
